// JsFromRoutes CacheKey 570a3ca9a88722966d43d34134af3fed
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  destroyAttachment: definePathHelper('delete', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:challenge_form_id/rebuttals/:id/supporting_docs/:file_id'),
  create: definePathHelper('post', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:challenge_form_id/rebuttals'),
  new: definePathHelper('get', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:challenge_form_id/rebuttals/new'),
  destroy: definePathHelper('delete', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:challenge_form_id/rebuttals/:id'),
}
